'use client';
import { Text } from '~components/Typography';
import { useChatsCount } from '~entities/chats/hooks/useChatsCount';
import { useNavigationLinks } from '~hooks/useNavigationLinks';
import type { ExtendedNavigationPath } from '~hooks/useNavigationLinks/types';
import { useTranslations } from '~i18n/hooks';
import { ButtonPrimary } from '~shared/ui/atoms/Buttons/ButtonPrimary';
import { ButtonStroked } from '~shared/ui/atoms/Buttons/ButtonStroked';
import { useHeaderContext } from '~widgets/Header/context';

import { StyledGroup } from '../styles';
import { StyledLink, StyledSubheadline } from './styles';

export const Content = () => {
	const { sideMenuClose } = useHeaderContext();
	const links = useNavigationLinks(true);
	const t = useTranslations('SideMenu');

	const { unreadMessagesCount } = useChatsCount();

	return (
		<>
			{links.map((group) =>
				'children' in group ? (
					<StyledGroup key={group.text || group['data-name']}>
						{group.text && (
							<StyledSubheadline
								data-name={group['data-name']}
								align="left"
								transform="uppercase"
							>
								{group.text}
							</StyledSubheadline>
						)}
						{group.children.map((el: ExtendedNavigationPath) => (
							<StyledLink
								data-name={el['data-name']}
								active={el.active ? 1 : 0}
								disabled={el.disabled ?? false}
								key={el.text}
								href={el.path}
								forceNativeLink={el.targetBlank}
								onClick={(e) => {
									el.handle(e);
									sideMenuClose();
								}}
							>
								<Text align="left" size="M">
									{el.text}
								</Text>
								{el.disabled && (
									<ButtonStroked disabledInteraction={true} size="Badge">
										{t('menuComingSoonLabel')}
									</ButtonStroked>
								)}
								{el.new && (
									<ButtonPrimary disabledInteraction={true} size="Badge">
										{t('menuNewLabel')}
									</ButtonPrimary>
								)}
								{el.withMessageCounter && !!unreadMessagesCount && (
									<ButtonStroked disabledInteraction={true} size="Badge">
										{/* TODO: proper translation for cost with a template {number} */}
										{unreadMessagesCount} {t('menuUnreadLabel')}
									</ButtonStroked>
								)}
							</StyledLink>
						))}
					</StyledGroup>
				) : null
			)}
		</>
	);
};
